import { Drawer, Row, Col, Input } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import SearchIcon from "../../assets/images/searchIcon.svg";
import Close from "../../assets/images/close-x.svg";
import DefaultProductImage from "../../assets/images/no-image.svg";

const ChooseProductDrawer = ({
  chooseProduct,
  setChooseProduct,
  chooseSearchedProduct,
  setChooseSearchedProduct,
  chooseProductsData,
  selectedProductIndex,
  handleProductSelect,
  handleScroll,
  scrollRef,
  inputRef,
}) => {
  return (
    <Drawer
      closable={false}
      placement="bottom"
      open={chooseProduct}
      closeIcon={null}
      maskClosable={false}
      className="filter"
      headerStyle={{ background: "#f3f4f9", borderBottom: "none", padding: "0.5rem 1.5rem" }}
      styles={{ body: { paddingBottom: 0, paddingTop: 0, background: "#f3f4f9" } }}
      onClose={() => {
        setChooseProduct(false);
        setChooseSearchedProduct("");
      }}
      height="85vh"
    >
      <div style={{ position: "relative", padding: "1vh 1vw" }}>
        <img
          src={Close}
          onClick={() => {
            setChooseProduct(false);
            setChooseSearchedProduct("");
          }}
          style={{
            cursor: "pointer",
            width: "1.5vw",
            position: "absolute",
            top: "2vh",
            right: "0.2vw",
          }}
          alt="Close"
        />
      </div>
      <Row
        gutter={[8, 0]}
        style={{
          marginTop: "2vh",
          borderRadius: "10px",
          paddingLeft: "1.5vw",
          fontSize: "1vw",
          display: "flex,",
          justifyContent: "center",
        }}
      >
        <Col span={22}>
          <p style={{ fontSize: "1.5em", fontWeight: 500, fontFamily: "Inter" }}>Trays ({chooseProductsData?.length})</p>
          <Input
            type="text"
            ref={inputRef}
            placeholder="Search for products by code/name"
            id="giftCardSearchInput"
            style={{
              width: "97%",
              padding: "5px",
              borderRadius: "5px",
              fontSize: "1vw",
              color: "#0F0718",
              height: "6vh",
              marginLeft: "0.105rem",
            }}
            prefix={<img src={SearchIcon} alt="" style={{ height: "2.7vh", marginLeft: "0.3rem" }} />}
            value={chooseSearchedProduct}
            onChange={(ev) => {
              setChooseSearchedProduct(ev.target.value);
              localStorage.setItem("productName", ev.target.value);
            }}
          />
        </Col>
      </Row>
      <Scrollbars ref={scrollRef} className="productionScroll" onScrollFrame={handleScroll}>
        <Row
          style={{
            borderRadius: "10px",
            fontSize: "1vw",
            display: "flex,",
            justifyContent: "center",
          }}
        >
          {chooseProductsData?.map((product, index) => {
            const isSelected = index === selectedProductIndex;
            return (
              <Col
                key={product?.key}
                id={`product-${index}`}
                span={4}
                style={{
                  background: "#fff",
                  border: isSelected ? "2px solid #929098" : "2px solid transparent",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0rem 0.5rem",
                  flex: "0 0 100%",
                  marginTop: "2vh",
                  marginRight: "1vw",
                  cursor: "pointer",
                }}
                onClick={handleProductSelect(product)}
              >
                <img src={product?.imageurl !== null ? product?.imageurl : DefaultProductImage} alt="" style={{ margin: "0.7rem 0", height: "6rem" }} />
                <span style={{ textAlign: "center", margin: "0.7rem 0" }}>
                  <p style={{ margin: 0, fontWeight: 500, fontSize: "1em", color: "#0F0718" }}>{product?.name}</p>
                  <span style={{ fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>{product?.value}</span>
                </span>
              </Col>
            );
          })}
        </Row>
      </Scrollbars>
    </Drawer>
  );
};

export default ChooseProductDrawer;
